module.exports = __webpack_public_path__ + "img/02-01-img-01@2x.4f7e4889.png";